import React, { useEffect, useState, useMemo } from 'react';
import { MastheadSkeletonSSR } from '@/packages/ldp-core-sdm/src/skeletons/masthead-ssr/masthead-skeleton-ssr';
import MastheadSSRComponent from './masthead-ssr';

// Extract logo data from headerSection for SSR skeleton
export const extractLogoData = (headerSection: any) => {
  try {
    const logoSection = headerSection?.logoSection?.components?.[0]?.data;
    if (!logoSection) return undefined;

    return {
      largeLogo: {
        url: logoSection?.largeLogo?.url,
        altText: logoSection?.largeLogo?.altText,
      },
      callToAction: {
        url: logoSection?.callToAction?.url,
      },
    };
  } catch {
    return undefined;
  }
};

interface MastheadSSRWrapperProps {
  headerSection: any;
}

// Wrapper component to show masthead skeleton until the real component is ready
export const MastheadSSRWrapper = ({ headerSection }: MastheadSSRWrapperProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const logo = useMemo(() => extractLogoData(headerSection), [headerSection]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Show skeleton until the real masthead is ready.
  if (!isMounted) {
    return (
      <MastheadSkeletonSSR logo={logo} />
    );
  }

  return <MastheadSSRComponent headerSection={headerSection} />;
};

export default MastheadSSRWrapper;
